'use strict';

import template from './modal.html';

// More than slideshow (for delete, rotate photo actions)
const INITIAL_Z_INDEX = 2000;
const saModal = [
  '$rootScope',
  'modal',
  'bodyScroll',

  function ($rootScope, modal, bodyScroll) {
    return {
      transclude: true,
      replace: true,
      template: template,
      link: function postLink($scope, $element) {
        $element.css('z-index', INITIAL_Z_INDEX + $scope.modalInstance.index);
        bodyScroll.disable();

        $scope.dismiss = $scope.modalInstance.dismiss;
        $scope.close = $scope.modalInstance.close;
        $scope.closeOff = $scope.modalInstance.closeOff;
      }
    };
  }
];

export default saModal;



// WEBPACK FOOTER //
// ./app/src/directives/modal.js